var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("path", {
    d: "M9 12a9.647 9.647 0 01-6.692-2.827A12.012 12.012 0 01.1 6.331.6.6 0 010 6a.593.593 0 01.131-.373 14.937 14.937 0 012.451-2.85A9.8 9.8 0 019 0a9.8 9.8 0 016.418 2.776 14.956 14.956 0 012.451 2.851.6.6 0 01.033.7v.011a11.96 11.96 0 01-2.225 2.856A9.641 9.641 0 019 12zM9 1.8A4.2 4.2 0 1013.2 6 4.205 4.205 0 009 1.8zm0 6A1.8 1.8 0 1110.8 6 1.8 1.8 0 019 7.8z",
    transform: "translate(3 6)",
    fill: "#373a3d"
  })), /*#__PURE__*/React.createElement("style", null))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-311 -16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 12a9.647 9.647 0 01-6.692-2.827A12.012 12.012 0 01.1 6.331.6.6 0 010 6a.593.593 0 01.131-.373 14.937 14.937 0 012.451-2.85A9.8 9.8 0 019 0a9.8 9.8 0 016.418 2.776 14.956 14.956 0 012.451 2.851.6.6 0 01.033.7v.011a11.96 11.96 0 01-2.225 2.856A9.641 9.641 0 019 12zM9 1.8A4.2 4.2 0 1013.2 6 4.205 4.205 0 009 1.8zm0 6A1.8 1.8 0 1110.8 6 1.8 1.8 0 019 7.8z",
    transform: "translate(311 16)",
    fill: "#373a3d"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.76bc96bc.svg";
export { ForwardRef as ReactComponent };